import styled from "styled-components";
import { remCalc } from "utilities/styles";
import { Roboto } from "utilities/variables/fonts";

import { menuZIndex } from "utilities/variables/zIndex";
import { dark, lightGrey, white, red } from "utilities/variables/colors";


export const SubscribeBackToStockDropdownContainer = styled.div`
   position: relative;
   width: 100%;

  .bts-button {
		width: ${remCalc(40)};
		height: ${remCalc(40)};
		padding: 0;
		display: grid;
		place-items: center;
		border-color: ${lightGrey};
		background-color: ${white};

		&.active,
		&:hover,
		&:active {
			border-color: ${dark};
		}

		i {
			font-size: ${remCalc(32)};
		}
	}

  .bts-container{
    z-index: ${menuZIndex};
	position: absolute;
	right: 0;
	display: flex;
	flex-direction: column;
	box-shadow: 0px 3px 6px #21252940;
	background-color: ${white};
	min-width: 300px;
	max-width: 450px;
	padding: 20px;
	
	@media (max-width: 768px) {
         right: initial;
    }

	& > * {
		width: 100%;
		height: fit-content;

		// border-bottom: 1px solid ${lightGrey};
		background-color: ${white};

		// white-space: nowrap;
		text-align: start;

		font: bold ${remCalc(16)} / ${remCalc(20)} ${Roboto};
		letter-spacing: ${remCalc(0.8)};
		// text-transform: uppercase;
		font-weight: 600;

		&:hover,
		&:active {
			background-color: ${white};
			border-color: ${white};
			border-bottom-color: ${lightGrey};
			color: ${dark};
			text-decoration: underline;
		}

		&:last-child {
			border: none;
			padding-top: ${remCalc(16)};
			padding-bottom: ${remCalc(24)};
		}
  }

  .bts-title{
	margin-bottom: 0px;
	text-align: center; 
	font-size: 20px; 
	font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; 
	font-weight: 600;
	color: rgb(2,2,2);
  }
 
  .bts-subtitle{
  	text-align: center; 
	font-size: 14px; 
	font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif; 
	font-weight: 600;
	font-transform: initial;
	color: rgb(2,2,2);
  }

  .bts-email-input {
    width: 100%;
	box-sizing: border-box;
	border-radius: 4px;
	padding: 0px 0px 0px 16px;
	height: 54px;
	text-align: left;
	color: #000000;
	font-family: "Nunito-Sans-Klaviyo-Hosted", Arial, "Helvetica Neue", Helvetica, sans-serif;
	font-size: 18px;
	font-weight: 400;
	letter-spacing: 0px;
	background-color: #ffffff;
	border: 1px solid rgb(96, 106, 114);
}

.bts-button-container{
	padding: 10px 0px;
}

.bts-button-input {
	background: rgb(0, 0, 0);
	border-radius: 6px;
	border-style: none;
	border-color: rgb(27, 27, 27);
	border-width: 2px;
	color: rgb(255, 255, 255);
	font-family: Roboto, Helvetica, Arial, sans-serif;
	font-size: 20px;
	font-weight: 700;
	letter-spacing: 0px;
	line-height: 1;
	font-style: normal;
	white-space: normal;
	padding-top: 0px;
	padding-bottom: 0px;
	text-align: center;
	word-break: break-word;
	align-self: flex-end;
	cursor: pointer;
	pointer-events: auto;
	height: 54px;
	width: 100%;
}

.bts-container .input-container {
  position: relative !important;
}
.bts-error{
  color: #d23320;
  font-size: 13px;
  font-weight: normal;
  font-family: Roboto, Helvetica, Arial, sans-serif;
}

.email-error.bts-error {
  position: absolute;
  right: 20px;
  bottom: 37px;
  width: auto;
  padding: 7px;
  background-color: #fff4f0;
  border: 1px solid #d23320;
  border-radius: 4px;
}

.email-error.bts-error::before {
	content: "";
	position: absolute;
	top: -6px;
	left: 10%;
	width: 10px;
	height: 10px;
	transform: rotate(45deg);
	border-top: 1px solid rgb(210, 51, 32);
	border-left: 1px solid rgb(210, 51, 32);
	background-color: #fff4f0;
}
.bts-success-message {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	width: 345px;
	height: 180px;
	color: rgb(2,2,2) !important;
	font-size: 19px;
	font-weight: normal;
}
`;
